<template>
  <div
    id="app"
    class="app-root"
    :style="{
      overflow: modal.action ? 'hidden' : 'auto',
      '--window-height': windowHeight + 'px',
      '--window-width': windowWidth + 'px',
      '--header-height': headerHeight + 'px',
      '--footer-height': footerHeight + 'px',
      '--scroll-size': scrollbarSize + 'px'
    }"
    @mousemove="e => setAFKCountDown()"
    @mousedown="e => setAFKCountDown()"
    @mousewheel="e => setAFKCountDown()"
    @keypress="e => setAFKCountDown()"
  >
    <div id="scroll-box"></div>
    <template v-if="isReportPage">
      <router-view />
    </template>
    <template v-else>
      <layout-header v-if="isMobile"></layout-header>
      <div id="app-container" class="app-container row-block" :style="{ position: modal.action && !isDialogLoading ? 'relative' : 'relative' }">
        <layout-sidebar v-if="!isMobile" :minHeight="minHeight"></layout-sidebar>
        <div class="app-pages col-block" :style="{ flex: 1, height: minHeight + 'px' }">
          <div v-if="currentBackground" class="app-background" :style="currentBackground"></div>
          <div class="app-main-container col-block width-full" :style="{ flex: 1, height: 0 }">
            <router-view :minHeight="minHeight" />
          </div>
          <layout-footer></layout-footer>
        </div>
      </div>
      <div class="modal-container">
        <modal :action="modal.action" :type="modal.type" :style="!isDialogLoading ? {} : { display: 'none' }" :width="modal.width" :height="modal.height" :customStyles="modal.customStyles" :maskClose="modal.maskClose" :autoHeight="modal.autoHeight" @hide="() => {
          modal.callback && modal.callback()
          setModalAction({})
        }">
          <component :is="modal.action" :param="modal.param" @changeModal="(option, param) => {
            modal.callback && modal.callback(param)
            this.setModalAction(option || {})
          }"></component>
        </modal>
        <modal :action="modal2.action" :type="modal.type" :style="!isDialogLoading ? {} : { display: 'none' }" :width="modal2.width" :height="modal2.height" :customStyles="modal2.customStyles" :maskClose="modal2.maskClose" :autoHeight="modal2.autoHeight" @hide="() => {
          modal2.callback && modal2.callback()
          setModal2Action({})
        }">
          <component :is="modal2.action" :param="modal2.param" @changeModal="(option, param) => {
            modal2.callback && modal2.callback(param)
            this.setModal2Action(option || {})
          }"></component>
        </modal>
      </div>
      <layoutToast></layoutToast>
      <layoutBorCor></layoutBorCor>
      <layoutLoading v-if="isLoading"></layoutLoading>
      <layoutUploading v-if="isUploading !== undefined" :content="isUploading"></layoutUploading>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { getUserToken } from './api'
import layoutSidebar from './components/layout/sidebar.vue'
import layoutHeader from './components/layout/header.vue'
import layoutFooter from './components/layout/footer.vue'
import layoutToast from './components/layout/toast.vue'
import layoutBorCor from './components/layout/borCor.vue'
import layoutLoading from './components/layout/loading.vue'
import layoutUploading from './components/layout/uploading.vue'
import responsitive from './mixins/responsitive.vue'
import toastMethods from './mixins/toastMethods.vue'
import locale from './mixins/locale.vue'
import loginData from './mixins/loginData.vue'
// modals
import modal from './components/dialog/container.vue'
import selectIdentity from './components/dialog/selectIdentity.vue'
import phenotypeMore from './components/dialog/phenotypeMore.vue'
import resourceMap from './components/dialog/resourceMap.vue'
import toast from './components/dialog/toast.vue'

require('font-awesome-sass-loader')

export default {
  name: 'app',
  components: {
    layoutSidebar,
    layoutHeader,
    layoutFooter,
    layoutToast,
    layoutBorCor,
    layoutLoading,
    layoutUploading,
    // modals
    modal,
    selectIdentity,
    phenotypeMore,
    resourceMap,
    toast
  },
  mixins: [
    responsitive,
    toastMethods,
    locale,
    loginData
  ],
  metaInfo () {
    return {
      title: this.$t('LAYOUT.header.___webTitle'/* 網頁標題 */)
    }
  },
  data () {
    return {
      userAgent: '',
      afkCountDownTimer: null
    }
  },
  watch: {
    '$route' () {
      const { body } = document
      body.scroll(0, 0)
      document.getElementById('app').scroll(0, 0)
      this.setModalAction({})
      this.setModal2Action({})
      this.clearSubLoadingAction()
      this.setAFKCountDown()
      window.dispatchEvent(new Event('resize'))
      if (this.initial !== null) {
        let user = this.user || {}
        this.setLoadingAction(true)
        this.validateRoute(this.isLogin, user.role, user.admin)
      }
    },
    async 'isLogin' (n, o) {
      this.setAFKCountDown()
      if (o !== null) {
        this.setLoadingAction(true)
        await this.preFetchDataGuest()
        if (n) {
          await this.preFetchData()
        } else {
          this.setUnloadAlertAction()
        }
        this.appInitialAction(n)
        this.setLoadingAction(false)
      }
    },
    'unloadAlert' (nv) {
      if (nv) {
        window.document.body.onbeforeunload = function () { return '' }
      } else {
        window.document.body.onbeforeunload = null
      }
    },
    'loading' (nv) {
      this.setAFKCountDownAction({ active: !nv })
    },
    'isUploading' (nv) {
      this.setAFKCountDownAction({ active: nv === undefined })
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'normalPage',
      'userPage',
      'adminPage',
      'initial',
      'isLogin',
      'isLoading',
      'isDialogLoading',
      'isUploading',
      'modal',
      'modal2',
      'unloadAlert',
      'afkCountDown'
    ]),
    minHeight () {
      return this.windowHeight - this.headerHeight - this.footerHeight
    },
    currentBackground () {
      let currentBackground = {
      }[this.$route.name]
      return currentBackground ? { 'background-image': 'url(' + currentBackground.url + ')', ...currentBackground.style } : null
    },
    isReportPage () {
      return this.$route.name && [
        'report',
        //
        ''
      ].includes(this.$route.name)
    }
  },
  created () {
    this.userAgent = navigator.userAgent
    this.setLocale()
    this.setModalAction({})
    this.setModal2Action({})
    this.setLoadingAction(true)
    this.setAFKCountDown()
    const validateLogin = () => {
      if (this.$route.name) {
        this.validateLogin()
      } else {
        setTimeout(() => validateLogin(), 100)
      }
    }
    validateLogin()
  },
  mounted () {
    window.addEventListener('scroll', () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      let offsetHeight = document.documentElement.offsetHeight || document.body.offsetHeight
      this.setScrollStateAction({
        top: scrollTop,
        height: scrollHeight - offsetHeight
      })
    })
  },
  methods: {
    ...mapActions([
      'appInitialAction',
      'setLoadingAction',
      'setDialogLoadingAction',
      'clearLoadingAction',
      'clearSubLoadingAction',
      'clearDialogLoadingAction',
      'setModalAction',
      'setModal2Action',
      'setUnloadAlertAction',
      'setScrollStateAction',
      'setAFKCountDownAction'
      // global
    ]),
    setLocale () {
      const langMap = l => {
        if (!l) return null
        l = l.toLowerCase()
        // if (l === 'zh-cn') return 'tc'
        // if (l.startsWith('zh')) return 'tc'
        if (l === 'ja') return 'ja'
        return 'en'
      }
      let locale = localStorage.getItem('locale')
      if (!this.languageOptions.map(option => option.value).includes(locale)) {
        locale = langMap(window.navigator.language || navigator.userLanguage) || 'en'
      }
      this.setLang(locale)
    },
    async preFetchDataGuest () {
    },
    async preFetchData () {
    },
    async validateLogin () {
      let userInfo = this.$ls.get('userInfo') || {}
      await this.preFetchDataGuest()
      if (userInfo['access-token']) {
        await this.getUserByToken(userInfo)
      } else {
        this.setUserData(null)
        this.appInitialAction(false)
        this.validateRoute(false)
      }
    },
    async getUserByToken (data) {
      try {
        let response = await getUserToken(data)
        await this.preFetchData()
        let user = this.setUserData(response, data) || { role: {} }
        this.appInitialAction(true)
        this.validateRoute(true, user.role, user.admin)
      } catch (error) {
        this.setUserData(null)
        this.appInitialAction(true)
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        this.validateRoute(false)
      }
    },
    validateRoute (isLogin, role, admin) {
      let array = []
      if (isLogin) {
        switch (role) {
          default: {
            array = _.union(this.userPage, this.normalPage)
          }
        }
      } else {
        array = this.normalPage
      }
      if (admin) {
        array = _.union(array, this.adminPage)
      }
      this.validateRole(isLogin, array)
    },
    validateRole (isLogin, pages) {
      let routeName = this.$route.name
      if (routeName && !_.includes(pages, routeName)) {
        this.addToast('error', isLogin ? this.$t('COMMON.toast.___noPermission'/* 權限不足 */) : this.$t('COMMON.toast.___pleaseLogin'/* 請先登入 */))
        this.$router.push(isLogin ? { name: 'main' } : { name: 'main', query: { redirect: this.$route.fullPath } })
        this.setLoadingAction(false)
      } else {
        if (isLogin && _.includes(this.normalPage, routeName) && !['redirect'].includes(routeName)) {
          this.$router.push({ name: 'main' })
        }
        this.setLoadingAction(false)
      }
    },
    setAFKCountDown (value) {
      value = value || value === 0 ? value : this.afkCountDown.default
      this.setAFKCountDownAction({ value: value })
      // if (!this.afkCountDownTimer) {
      //   this.afkCountDownTimer = setInterval(() => {
      //     this.setAFKCountDown(this.afkCountDown.active ? this.afkCountDown.value - this.afkCountDown.interval : this.afkCountDown.default)
      //   }, this.afkCountDown.interval)
      // }
    }
  }
}
</script>

<style lang="sass">
@import sass/style
</style>



// WEBPACK FOOTER //
// src/App.vue